const initialState = {
  metaData : undefined,
  menu : {
    isShow : false,
    stationSetting : {
      chatLinkEmployeeToUser:""
    }
  }
};
export default function commonReducer(state = initialState, action) {
  switch (action.type) {
    case "META_DATA":
      return {
        ...state,
        metaData: action.data,
      };
    case "MENU":
      return {
        ...state,
        menu: action.data
      };
    default:
      return state;
  }
}
